import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useClientAuth } from "@/context/ClientAuth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useClientAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const r = await fetch(`${API}/client-auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!r.ok) throw new Error("session exchange failed");
        // Clear the fragment from URL
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        navigate("/account", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg text-brand-muted">
      Signing you in…
    </div>
  );
}
